import { styled, DSCol } from '@vr/ds-react'

export const BoxHeader = styled('div', {
  backgroundColor: '$neutralLight',
  borderRadius: '$borderRadiusSmall',
  fontSize: '$extraSmall',
  fontWeight: '$semiBold',
  lineHeight: '$extraLarge',
  padding: '$sm16'
})

export const BoxContent = styled('div', {
  display: 'flex',
  flexDirection: 'column !important',
  justifyContent: 'center !important',
  gap: 15,
  backgroundColor: '$neutralVeryLight',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: '$neutralMedium',
  borderRadius: '$borderRadiusSmall',
  fontSize: '$extraSmall',
  fontWeight: '$semiBold',
  lineHeight: '$extraLarge',
  padding: '$sm16',
  marginBottom: '$sm16'
})

export const ContentCol = styled(DSCol, {
  display: 'flex',
  flexDirection: 'column !important',
  justifyContent: 'center !important',
  gap: 15
})
